// dependencies
import Modal from 'react-modal'
import { styled, Grid } from '@mui/material'
import { breakPoints } from '@constants/styles'

export const StyledShowroomVisitForm = styled('div')(({ theme }) => ({
  '.MuiFormControl-root': {
    'label:not(.Mui-focused)': {
      color: theme.palette.grey[500],
    },
    'label.MuiInputLabel-shrink': {
      transform: ' translate(14px, -9px) scale(0.75)',
    },
    div: {
      fieldset: {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
    },
  },
  '.MuiFormControlLabel-root': {
    'span:not(.Mui-checked)': {
      svg: {
        color: theme.palette.grey[500],
      },
    },
  },
  '.MuiGrid-item': {
    padding: '8px 0 0 8px',
  },
  'input:-webkit-autofill': {
    WebkitBoxShadow: 'unset',
    WebkitTextFillColor: 'unset',
  },
}))

// TODO: Remove older calendar legacy code, as we're using muix date-picker now.
export const SchedulerModal = styled(Modal)({
  margin: 'auto',
  padding: '2rem',
  background: '#fff',
  border: 'solid #ccc 0.4rem',
  width: '60rem',
  [`@media screen and (max-width: ${breakPoints['large-min']})`]: {
    padding: '1rem',
    width: '90%',
  },
})

export const CloseButton = styled('button')({
  position: 'relative',
  background: '#0053a0',
  width: '2.5rem',
  height: '2.5rem',
  borderRadius: '50%',
  float: 'right',
  marginTop: '-15px',
  '> .close': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    height: '2rem',
    margin: 'auto',
    width: '100% !important',
    backgroundSize: '100% !important',
    [`@media only screen and (min-device-width: 374px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape)`]: {
      marginTop: '0.3rem !important',
    },
  },
})

export const Heading = styled('p')({
  marginTop: '10px',
  fontSize: '24px',
  fontWeight: 'normal',
  color: '#0053a0',
  textAlign: 'left',
})

export const Subheading = styled('p')({
  fontSize: '16px',
  margin: '1rem 0',
})

export const Button = styled('button')(({ disabled }) => ({
  background: '#0053a0',
  fontSize: '0.8rem',
  color: 'white',
  padding: '1.2rem 1.5rem',
  borderRadius: '6px',
  fontWeight: '600',
  cursor: disabled ? 'not-allowed' : 'pointer',
}))

export const ChangeLocationButtonWrapper = styled('div')({
  height: '55px',
  alignSelf: 'end',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    alignSelf: 'start',
    marginTop: '10px',
  },
})

export const LocationPinWrapper = styled('div')({
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    width: '13px',
  },
})

export const SubmitButton = styled('div')({
  marginTop: '30px',
})

export const ErrorMessage = styled('p')(({ shouldShow }) => ({
  color: '#eb141f',
  fontSize: '1rem',
  visibility: shouldShow ? 'visible' : 'hidden',
  margin: '0.5rem 0',
}))

export const SuccessMessage = styled('p')({
  textAlign: 'center',
  color: '#008550',
  fontSize: '1rem',
  margin: '0.5rem 0',
})

export const LocationSection = styled('div')({
  backgroundColor: '#e4f2fe',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '20px 30px',
  margin: '28px 0',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    flexDirection: 'column',
  },
})

export const LocationTitle = styled('div')({
  height: '48px',
  width: '100%',
  color: '#0053a0',
  fontSize: '18px',
  fontWeight: 'bold',
  letterSpacing: '0.23px',
  lineHeight: '24px',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    marginTop: '-20px',
    marginLeft: '17px',
  },
})

export const LocationAddress = styled('div')({
  width: '312px',
  color: '#0053a0',
  fontSize: '16px',
  letterSpacing: 0,
  lineHeight: '24px',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    width: '100%',
  },
})

export const LocationPhone = styled('div')({
  height: '57px',
  width: '312px',
  color: '#0053a0',
  fontSize: '16px',
  letterSpacing: 0,
  lineHeight: '24px',
})

export const LocationOpeningTime = styled('div')({
  height: '24px',
  width: '312px',
  color: 'rgba(0, 0, 0, 0.85)',
  fontSize: '16px',
  letterSpacing: 0,
  lineHeight: '24px',
})

export const RequiredFieldsMessage = styled('div')({
  fontSize: '11px',
  letterSpacing: 0,
  lineHeight: '30px',
  textAlign: 'right',
  '& > span': {
    color: '#eb141f',
  },
})

export const SeniorMessage = styled('div')({
  fontSize: '15px',
  letterSpacing: 0,
  lineHeight: '20px',
  maxWidth: '300px',
  marginLeft: '10px',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    display: 'block',
    maxWidth: '100%',
    marginTop: '10px',
  },
})

export const RedSpan = styled('span')({
  color: '#eb141f',
  fontStyle: 'italic',
})

export const DateTimeFlexContainer = styled(Grid)({
  display: 'flex',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    display: 'block',
  },
  '.MuiFormControl-root': {
    width: '100%',
  },
})

export const DateTimeArrow = styled('span')({
  color: '#a6a6a6',
  fontSize: '30px',
  margin: '10px',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    display: 'none',
  },
})

export const TimeFieldWrapper = styled('div')({
  display: 'inline',
  width: '193px',
  [`@media screen and (max-width: ${breakPoints.small})`]: {
    display: 'block',
    width: '100%',
    marginTop: '10px',
  },
})

export const DateInput = styled('input')({
  height: '2.2rem',
  width: '100%',
  cursor: 'pointer',
})

export const Label = styled('label')({
  color: '#565f6f',
  fontWeight: 'bold',
  margin: '0 0.5rem',
  minWidth: '3rem',
  fontSize: '0.8rem',
})
